import { useSelector } from 'react-redux';
// Utils
import { formatThousandSeparator } from '../../utils/formatThousandSeparator';
// Style
import './SummarySearch.css';
// Translate
import { useTranslation } from 'react-i18next';

const SummarySearch = ({ total = 0, term = '' }) => {
	const { t } = useTranslation();
	const { queryFetched } = useSelector((state) => state.library);
	if (queryFetched) {
		return (
			<div className='summarySearch'>
				<h3 className='summarySearchQuery'>
					{t('Searched term')}:{' '}
					{term ? term : queryFetched}
				</h3>
				<p className='summarySearchTotal'>
					{formatThousandSeparator(total)}{' '}
					{t('results')}
				</p>
			</div>
		);
	} else {
		return null;
	}
};

export default SummarySearch;
